import React from "react";
import { InfinitySpin } from "react-loader-spinner";

export default function BackdropLoader({ loading, handleClose }) {
  if (!loading) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[var(--primary-background)]/40 bg-opacity-50 z-50"
      onClick={handleClose}
    >
      <InfinitySpin width="200" color="#7dd3fc" />
    </div>
  );
}
